module.exports = __webpack_public_path__ + "static/media/icon-start.2e367de7.svg";